import { useMutation, useQueryClient } from '@tanstack/react-query'
import { notification } from '@surecompanies/core_components'
import dayjs, { Dayjs } from 'dayjs'
import client from 'enrollment-platform/api/eps.client'

export default function useUploadResult(id: number | null) {
  const queryClient = useQueryClient()
  const onUploadResult = async (file: File, uploadedDate: Dayjs) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('uploadedDate', dayjs(uploadedDate).format('YYYY-MM-DD'))
      const response = await client.post(
        `/payroll/manual/${id}/upload`,
        formData
      )
      notification.success({
        message: 'Upload result successful',
      })
      queryClient.invalidateQueries({
        queryKey: ['getAssistedPayroll'],
      })
      return response.data
    } catch (error) {
      notification.error({
        message: 'Upload result failed',
      })
    }
  }
  const { mutate: uploadResult, isPending } = useMutation({
    mutationFn: (params: { file: File; uploadedDate: Dayjs }) =>
      onUploadResult(params.file, params.uploadedDate),
  })
  return {
    isPending,
    uploadResult,
  }
}
